import {formatDate} from "@ui-seeker/utils";
import {NotAllowedBlock} from "@components";
import * as React from "react";


export default function dateColumn(name, label) {
    return {
        name: name,
        label: label,
        options: {
            headerAlign: 'left',
            customBodyRowRender: value => {
                if (!value) return <NotAllowedBlock />
                return formatDate(value, { isString: true })
            }
        }
    }
}